<vs-card theme="default" *vsLet="table?.dataSource?.meta$ | async as meta" class="block @container overflow-hidden">
  <vs-card-header
    class="[&>div]:!flex-wrap [&>div>div:first-child]:!min-w-[200px] [&>div>div:first-child>div]:!flex-nowrap !py-3 @xl:!py-4 !px-4 @xl:!px-5"
    [config]="{ title: 'Documents', subtitle: 'Manage and view all documents in the table below.' }"
  >
    <vs-badge
      *vsLet="(meta?.totalItems ?? null) as totalItems"
      slot="after-title"
      [class.italic]="totalItems === null"
      [class.animate-pulse]="totalItems === null"
    >
      {{ totalItems === null ? 'loading' : (totalItems | number) + ' documents' }}
    </vs-badge>

    <!-- (click)="new_note_dialog.open()" -->
    <button
      *ngIf="(hasUploadAccess$ | async) === true"
      vs-button
      size="md"
      slot="end"
      theme="primary"
      class="!w-full"
      (click)="upload_dialog.open()"
    >
      <vs-icon class="hidden sm:inline-block" name="upload-cloud-01"></vs-icon>
      Upload
    </button>
  </vs-card-header>

  <vs-card-content class="!p-0 @container">
    <vs-connected-table
      [endpoint]="endpoint$ | async"
      [columns]="columns$ | async"
      [cardContainer]="false"
    ></vs-connected-table>
  </vs-card-content>
</vs-card>

<vs-add-document-dialog
  #upload_dialog
  [canUpload$]="hasUploadAccess$"
  [hideUploadAndRunButton]="true"
  [customUploadEndpoint]="endpoint$ | async"
  (closed)="refresh()"
></vs-add-document-dialog>

<vs-edit-document-dialog
  [document]="itemToEdit"
  [hideStatusBadge]="true"
  [hideVisibilityInput]="true"
  [customEndpoint]="endpoint$ | async"
  (closed)="refresh()"
></vs-edit-document-dialog>
